export default __webpack_public_path__ + "static/get_app_bg-bf4946004aae7199ef0fa6748b7c8850.webp";